import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

export interface AgentCopilotAccess {
  copilotId: string;
  accessToken: string;
}

const initialState: AgentCopilotAccess = {
  copilotId: "",
  accessToken: "",
};

const agentCopilotAccessSlice = createSlice({
  name: "agentCopilotAccess",
  initialState,
  reducers: {
    setCopilotAccess: (_, { payload }: PayloadAction<AgentCopilotAccess>) => ({ ...payload }),
  },
});

export const { setCopilotAccess } = agentCopilotAccessSlice.actions;
export const selectCopilotAccess = (state: RootState): AgentCopilotAccess => state.agentCopilotAccess;

export default agentCopilotAccessSlice;
